'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Divider": "Polaris-Divider"
};

exports.default = styles;
